import {ContentType, GetFormData, Global, Header, http, Method} from './api-util';
import AuthUtil  from "@/utils/AuthUtil";

/**
 * 修改密码
 * @param {*} param0
 */
export const modifyPassword = async ({verify, password, newPassword}) => {
    await http({
        method: Method.POST,
        url: Global.BASE_URL + '/api/user/modify/password',
        data: {
            code: verify,
            password: password,
            newPassword: newPassword
        }
    });
};

/**
 * 修改用户信息
 * @param {*} param0
 */
export const modifyUserInfo = async ({
                                         avatar,
                                         nickname,
                                         gender,
                                         birthday
                                     }) => {
    const formData = GetFormData({
        avatarFile: avatar,
        nickName: nickname,
        gender,
        birthday
    });

    await http({
        method: Method.PUT,
        url: Global.BASE_URL + '/api/user/update',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });
};

/**
 * 用户信息
 */
export const userInfo = async () => {
    const {data} = await http({
        method: Method.GET,
        url: Global.BASE_URL + '/api/user/info'
    });

    let user = data.data;

    // this.id = info.id;
    // this.username = info.username;
    // this.avatar = info.avatar;
    // this.nickname = info.nickname;
    // this.gender = info.gender;
    // this.birthday = info.birthday;

    let info = {};
    if (user) {
        const {
            id,name,avatar,nickName,gender,birthday
        } = user || {};

        info = {
            id,avatar,gender,birthday,
            username: name,
            nickname: nickName
        }


        AuthUtil.setUserInfo(info)
    }


    return {
        info
    };
};

/**
 * 联系人信息
 */
export const contactInfo = async () => {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + '/cart/business/contact'
    })
        .then(res => res.data)
        .then(data => {
            const {name, telPhone: phone} = data;

            return {
                name,
                phone
            };
        });
};
